import React from 'react';
const ConnectionsHeader: React.FC = () => {
  return <div data-id="element-715">
      <h1 className="text-2xl font-semibold text-gray-800" data-id="element-716">
        Le mie connessioni
      </h1>
      <p className="text-sm text-gray-500 mt-1" data-id="element-717">
        Scopri e connettiti con altri professionisti della community EIIS
      </p>
    </div>;
};
export default ConnectionsHeader;